<div class="sticky top-16 z-[30] bg-white pb-2">
  <nav compact tuiSubheader class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <ng-container *ngIf="last">
          <strong *tuiItem tuiFade>{{ item }}</strong>
        </ng-container>
        <ng-container *ngIf="!last">
          <button *tuiItem tuiLink type="button">{{ item }}</button>
        </ng-container>
      </ng-container>
    </tui-breadcrumbs>
  </nav>

  <div class="items-center flex justify-between">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">
      {{ isWalkInMode ? 'View Walk-in Patient Charges' : 'View Extra Charges or Procedures' }}
    </p>
     <button
        tuiButton
        appearance="primary"
        size="m"
        routerLink="add-edit"
      >
        Add New Extra Charges
      </button>
  </div>


  <search class="lg:w-full mt-4 flex flex-col gap-3" tuiSearch style="padding-left: 0; margin-bottom: 20px;" [formGroup]="form">
    
    <div class="flex justify-between items-center w-full">
      
      <fieldset class="flex items-center gap-4 border-none m-0 p-0" tuiTextfieldSize="m">
        
        <div class="w-[431px]">
          <tui-textfield iconStart="@tui.search">
            <input formControlName="search" (keydown)="onSearchEnter($event)"
              [placeholder]="isWalkInMode ? 'Search by walk-in name, procedure, or nurse' : 'Search by procedure or nurse'"
              tuiTextfield />
          </tui-textfield>
        </div>


        <div class="w-[180px]" *ngIf="!isWalkInMode">
          <tui-combo-box formControlName="clientType" [stringify]="stringifyClientType">
            Client Type
            <input tuiTextfieldLegacy placeholder="All Types" />
            <tui-data-list-wrapper *tuiDataList [items]="clientTypeItems"
              [itemContent]="stringifyClientType | tuiStringifyContent" />
          </tui-combo-box>
        </div>

        <button (click)="applyFilters()" appearance="secondary" size="m" tuiButton type="button" class="w-full sm:w-auto"
          style="border: 2px solid #e5e7ea; font-weight: 800">
          Search
        </button>

        <button appearance="flat" iconStart="@tui.rotate-cw" tuiButton type="reset" (click)="clearFilters()">
          Clear
        </button>
      </fieldset>    
    </div>

    <div class="flex items-center gap-6 pl-1 mt-2">
      <p class="text-sm font-semibold text-[#26293C] m-0">
        Showing results for "{{ form.get('search')?.value || 'All Procedures' }}"
      </p>

      <label *ngIf="!isWalkInMode" class="flex items-center gap-2 text-sm font-medium text-[#191C30E5] select-none cursor-pointer"
        [appDisableUnlessPermission]="'PROCEDURE_UPDATE'">
        <input type="checkbox" [checked]="includeArchived" (change)="toggleIncludeArchived(!includeArchived)" />
        Show archived
      </label>
    </div>
    
  </search>
</div>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<div *ngIf="!isLoading" class="w-full mt-5 overflow-x-scroll">
  <table tuiTable [size]="size" [style.width.rem]="120">
    <thead>
      <tr>
        <th tuiTh style="background-color: #f9fbff; width: 300px;">
          Procedures
        </th>
        <th tuiTh style="background-color: #f9fbff">Nurse Name</th>
        <th tuiTh style="background-color: #f9fbff">Client Name</th>
        <th tuiTh style="background-color: #f9fbff">Client Type</th>
        <th tuiTh style="background-color: #f9fbff">Payment</th>
        <th tuiTh style="background-color: #f9fbff">Service Date</th>
        <th tuiTh style="background-color: #f9fbff">Actions</th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let record of procedures">
        <td tuiTd>{{ getProceduresDisplay(record) }}</td>
        <td tuiTd>{{ getNurseName(record) }}</td>
        <td tuiTd>{{ getClientDisplay(record) }}</td>
        <td tuiTd>{{ getClientTypeDisplay(record) }}</td>
        <td tuiTd>
          <span [tuiHint]="getPaymentBreakdown(record)" tuiHintDirection="top" tuiHintMode="onHover"
            class="text-[#526ED3]">
            LKR {{ getGrandTotal(record) | number : "1.2-2"}}
          </span>
        </td>
        <td tuiTd>{{ record.date | date: 'MMM d, y' }}</td>
        <td tuiTd>
          <span tuiStatus class="flex items-center gap-3">
            <span *ngIf="record.archived"
              class="text-[10px] font-semibold text-[#92400e] bg-[#fde68a] inline-block px-2 py-[1px] rounded-full">
              Archived
            </span>
            <button *ngIf="invoiceChargesLink(record) as invLink" type="button" [routerLink]="invLink"
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer mr-3"
              [appDisableUnlessPermission]="'INVOICE_VIEW'">
              View Invoice
            </button>
            <button *ngIf="walkInInvoiceLink(record) as walkInvLink" type="button" [routerLink]="walkInvLink"
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer mr-3"
              [appDisableUnlessPermission]="'INVOICE_VIEW'">
              View Invoice
            </button>
            <button *ngIf="!record.archived" [routerLink]="getEditRoute(record)"
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
              [appDisableUnlessPermission]="'EXTRA_CHARGES_UPDATE'">
              Edit
            </button>
            <button *ngIf="record.archived" type="button"
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
              (click)="restoreProcedure(record)" [appDisableUnlessPermission]="'EXTRA_CHARGES_UPDATE'">
              Restore
            </button>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Pagination -->
<div class="flex justify-end items-center mt-5">
  <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
  </tui-pagination>
</div>